import { instance } from '@/libs/api/instance'

/**
 * Get info about unread and required unread notifications count
 *
 * @return {Promise<AxiosResponse<any>>}
 */
export const getInfo = async () => {
  return instance.get('/v2/notification/info')
}
